import { useEffect, useState } from 'react';

export const tmtScriptSrc =
  'https://payment.tmtprotects.com/tmt-payment-modal.3.6.1.js';

/**
 * Load a script to the document head
 *
 * @param src Source of the script
 * @param onLoad On load callback
 * @param onError On error callback
 */
export function loadScript(src: string, onLoad, onError) {
  const script = document.createElement('script');
  script.src = src;
  script.onload = onLoad;
  script.onerror = (err) => {
    onError(err);
    script.remove();
  };
  document.head.appendChild(script);
}

/**
 * Use TMT Script Hook
 */
export function useTMTScript(maxRetries: number = 3) {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const [retries, setRetries] = useState<number>(0);

  useEffect(() => {
    // Check if the TMT script is loaded already
    const documentAlreadyHasScript = document.querySelector(
      `script[src="${tmtScriptSrc}"]`,
    );

    // If already loaded, use that
    if (documentAlreadyHasScript && (window as any).tmtPaymentModalSdk) {
      setLoading(false);
    }

    // If not and we have retries left, load the script
    else if (retries < maxRetries) {
      loadScript(
        tmtScriptSrc,
        () => setLoading(false),
        (err) => {
          console.log('Retrying to load the TMT Script');
          console.log(err);
          setRetries((prevRetries) => prevRetries + 1);
        },
      );
    }

    // Otherwise return the failure
    else {
      setLoading(false);
      setError(true);
      console.log('Failed to load the TMT Script');
    }
  }, [retries, maxRetries]);

  return [loading, error];
}
